module.exports = __webpack_public_path__ + "img/chili.4e615b83.svg";